
import { Vue, Component, Watch } from 'vue-property-decorator'
import DataSelect from '@/views/dataReport/template/dataSelect.vue'
import dayjs from 'dayjs'
import { moneyFormat } from '@/utils/util'
import { getOrderStatisticsSum, TotalDataDTO, getOrderStatisticsByOrder, getOrderStatisticsByGoods, getOrderStatisticsByCustomer, exportPullOrderStatistics } from '@/api/dataReport'
import OrderListCard from '@/views/dataReport/template/OrderListCard.vue'
import { getFileName } from '@/utils/fileUtil'
import { exportFileWithData } from '@/utils/h5ToApp'
import { Getter } from 'vuex-class'
import moment from 'moment'

@Component({
  components: {DataSelect, OrderListCard}
})
export default class ReturnGoodsOrder extends Vue {
  @Getter companyId!: string
  moneyFormat = moneyFormat

  readonly typeList = [
    {
      value: 1,
      text: '按订单明细统计',
      topTitle: '订单商品统计（按订单明细统计）',
      children: {
        goodsName: '商品名称',
        goodsCode: '商品编码',
        attrName: '商品规格',
        saleAmount: '数量',
        orderMoney: '金额小计',
        createTime: '下单时间',
      }
    }, {
      value: 2,
      text: '按商品统计',
      topTitle: '订单商品统计（按商品统计）',
      children: {
        goodsName: '商品名称',
        saleAmount: '数量',
        orderMoney: '金额小计',
      }
    }, {
      value: 3,
      text: '按客户&商品统计',
      topTitle: '订单商品统计（按客户&商品统计）',
      children: {
        goodsCode: '商品编码',
        goodsName: '商品名称',
        saleAmount: '数量',
        orderMoney: '金额小计',
      }
    }
  ]
  readonly format = 'YYYY-MM-DD'

  finished = false
  loading = false
  refreshing = false
  queryParams = {
    startTime: moment().month(moment().month() - 2).format(this.format),
    endTime: dayjs().format(this.format),
    type: 1,
    pageIndex: 1,
    pageSize: 10
  }

  totalData: TotalDataDTO | any = {} // 订单统计列表数据
  totalList = [
    {
      key: 'totalNumber',
      title: '订货单'
    },
    {
      key: 'totalOrderSum',
      title: '订货数量'
    },
    {
      key: 'totalMoney',
      title: '订货总金额',
      type: 'money'
    }
  ] // 订单统计列表

  list = []

  get fullTime () {
    return this.queryParams.startTime + '~' + this.queryParams.endTime
  }

  get ListTopTitle () {
    return this.typeList[this.queryParams.type - 1].topTitle
  }

  created () {
    this.getOrderStatisticsSum()
    this.handleFilter()
  }

  /**
   * 获取订单商品统计合计
   */
  getOrderStatisticsSum () {
    getOrderStatisticsSum({
      ...this.queryParams
    }).then(res => {
      this.totalData = res.data[0]
    })
  }

  handleDataChange (value: Array<string>) {
    this.queryParams.startTime = value[0]
    this.queryParams.endTime = value[1]
    this.load()
  }

  load () {
    this.finished = false
    this.list = []
    this.queryParams.pageIndex = 1
    this.queryParams.pageSize = 10
    this.getOrderStatisticsSum()
    this.handleFilter()
  }


  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.queryParams.pageIndex = 1
    this.refreshing = true
    this.load()
  }


  /**
   * 筛选回调
   */
  handleFilter () {
    this.loading = true
    const requests = [getOrderStatisticsByOrder, getOrderStatisticsByGoods, getOrderStatisticsByCustomer]
    requests[this.queryParams.type - 1]({
      ...this.queryParams
    }).then(res => {
      this.list = this.list.concat(res.data.records)
      if (this.list.length >= res.data.totalRecords) {
        this.finished = true
      }
      this.queryParams.pageIndex++
    }).finally(() => {
      this.loading = false
      this.refreshing = false
    })
  }

  /**
   * 导出数据
   */
  handleExport () {
    exportFileWithData({
      method:'post',
      portUrl:'/cykjreport/OR/exportPullOrderStatistics',
      params:JSON.stringify(Object.assign({companyId: this.companyId},{...this.queryParams}))
    })
    // exportPullOrderStatistics({
    //   ...this.queryParams
    // }).then((res: any) => {
    //   // exportFile()
    //   if (res.data instanceof ArrayBuffer) {
    //     let params = {
    //       fileData:String.fromCharCode.apply(null, new Uint8Array(res.data)),
    //       fileName: getFileName(res.headers['content-disposition'])
    //     }
    //     // exportFileWithData({...params})
    //   }
    // })
  }
}
